import React, { Component } from "react";

import withRouter from "./functions/withRouter";
import { getTrade, cancelTrade } from "./functions/trade";

import "./Shared.css";
import "./Book.css";

import Book from "./Book";

class TradeInProgress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      trade: null,
      cancelButton: <p className="Button" onClick={this.cancel}>Cancel Trade</p>
    }
  }

  componentDidMount() {
    getTrade(this.props.user).then((trade) => {
      this.setState({trade})
    });
  }

  cancel = () => {
    this.setState({cancelButton: <p className="Button Red" onClick={this.cancelConfirm}>Are you sure?! No refunds!</p>});
  }

  cancelConfirm = () => {
    cancelTrade(this.state.trade).then(() => this.setState({trade: null}));
  }

  renderTrade(trade) {
    let tradeStatus = "";

    if (trade.receivingBookSent) {
      tradeStatus = <div className="Row Center JustifyCenter TextBold"><div className="CircleIcon Green" /> Book sent! Check your mail</div>;
    } else if (trade.givingBookReceived) {
      tradeStatus = <div className="Row Center JustifyCenter TextBold"><div className="CircleIcon Green" /> Your new book will be sent shortly</div>;
    } else {
      tradeStatus = <div className="Row Center JustifyCenter TextBold"><div className="CircleIcon Orange" /> Waiting to receive your book</div>;
    }

    return (
      <div>
        <div className="Row JustifyCenter">
          <div className="Column Center">
            <div className="TextPadding TextSmall">Sending</div>
            <Book book={trade.givingBook} />
          </div>

          <img src="/foreword/images/exchange.png" alt="Exchange" className="ExchangeIcon ExchangeIconWhite" />

          <div className="Column Center">
            <div className="TextPadding TextSmall">Receiving</div>
            <Book book={trade.receivingBook} />
          </div>
        </div>

        <div className="Margin">{tradeStatus}</div>

        {!trade.givingBookReceived ? this.state.cancelButton : ""}
      </div>
    );
  }

  render() {
    const trade = this.state.trade;

    return (
      <div className={`Callout User ${(!trade) ? "NoTrade" : ""}`}>
        {this.props.children}
        {(trade) ? this.renderTrade(trade) : ""}
      </div>
    );
  }
}

export default withRouter(TradeInProgress);
